export const playPauseVideo = (video, videoControlElem) => {
    if (!video || !videoControlElem) {
        return;
    }

    const playIcon = videoControlElem.querySelector('.e__video-controls-image--play');
    const pauseIcon = videoControlElem.querySelector('.e__video-controls-image--pause');

    // Show the pause icon and hide the play icon
    playIcon.classList.add('hidden');
    pauseIcon.classList.remove('hidden');

    // Add a click event listener to the video control element
    videoControlElem.addEventListener('click', (event) => {
        event.preventDefault();

        if (video.paused) {
            video.play();
            
            playIcon.classList.add('hidden');
            pauseIcon.classList.remove('hidden');
        } else {
            video.pause();
            
            playIcon.classList.remove('hidden');    
            pauseIcon.classList.add('hidden');
        }
    });
};

export const resetVideoControls = (videoControlElem) => {
    if (!videoControlElem) {
        return;
    }

    const playIcon = videoControlElem.querySelector('.e__video-controls-image--play');
    const pauseIcon = videoControlElem.querySelector('.e__video-controls-image--pause');

    playIcon.classList.add('hidden');
    pauseIcon.classList.remove('hidden');
}